import { IBarighetsFilter } from "./IBarighetsFilter";
import { IProduktgruppFilter } from "./IProduktgruppFilter";
import { ISkogligdataFilter } from "./ISkogligdataFilter";
import { ISkotningAvstandFilter } from "./ISkotningAvstandFilter";
import { ITradslagsFilter } from "./ITradslagsFilter";
export class SkogligdataFilter implements ISkogligdataFilter {
    tillganglighet: IBarighetsFilter;
    produktgrupper: IProduktgruppFilter[];
    medelstamMin: number;
    medelstamMax: number;
    searchOnArbetsorder: boolean;
    produktgrupperBool: string;
    tradslag: ITradslagsFilter;
    skotningAvstand: ISkotningAvstandFilter;

    constructor() {
        this.medelstamMin = undefined;
        this.medelstamMax = undefined;
        this.searchOnArbetsorder = undefined;
    }
}
